module.exports = __webpack_public_path__ + "img/on_the_map.0987a983.jpg";